import React from "react";
import { useStyles } from "./AudienceListItem.styles";
import {
  Box,
  Chip,
  OverFlowTip,
  TruncateTooltip,
  Typography,
} from "@tiny/components";
import CloseSmall from "@tiny/icons/generated/CloseSmall";
import SortOption from "@tiny/icons/generated/SortOption";
import { SegmentView } from "@tiny/api";
import { toChipColor, toChipText } from "../../AudienceRow/AudienceRow.helper";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { format } from "date-fns";

const AudienceListItem = ({
  onDelete,
  audience,
}: {
  onDelete?: VoidFunction;
  audience: SegmentView;
}) => {
  const { name, segmentType, numberOfCustomers, createdAt } = audience;
  const { mdUp } = useBreakpoints();
  const classes = useStyles();
  const chipColor = React.useMemo(
    () => toChipColor(segmentType),
    [segmentType]
  );
  const chipText = React.useMemo(() => toChipText(segmentType), [segmentType]);
  const dateFormat = "dd MMM, yy - hh:mm a";
  let audienceName: React.ReactElement;
  if (mdUp) {
    audienceName = (
      <TruncateTooltip arrow>
        <Typography
          variant="label1"
          mr={2}
          className={classes.name}
          noWrap
          color="primary"
          tone="main"
        >
          {name}
        </Typography>
      </TruncateTooltip>
    );
  } else {
    audienceName = (
      <Typography
        variant="h4"
        mr={2}
        color="primary"
        tone="main"
        component="span"
      >
        {name && <OverFlowTip text={name} />}
      </Typography>
    );
  }
  return (
    <Box className={classes.container}>
      <Box className={classes.audienceDetailsLeft}>
        <Box className={classes.audienceName}>
          <Typography color="primary" tone="main">
            {audienceName}
          </Typography>
        </Box>
        <Box className={classes.audienceMeta}>
          <Chip color={chipColor} label={chipText} size="small" />
          <Typography variant="label2" tone={800} color="grey">
            Created {format(new Date(createdAt ?? ""), dateFormat)}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.audienceDetailsRight}>
        <Box className={classes.audienceCustomers}>
          <Typography variant="body2" tone={900} color="grey">
            {numberOfCustomers}
          </Typography>
          <Typography variant="label2" tone={700} color="grey">
            Customers
          </Typography>
        </Box>
        <Box>
          {onDelete ? (
            <CloseSmall onClick={onDelete} color="disabled" />
          ) : (
            <SortOption color="disabled" />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AudienceListItem;
